// extracted by mini-css-extract-plugin
module.exports = {"container":"tags_container__2vVgM"};